export default "__VITE_ASSET__B2Mt13ZN__"